import React from "react";
import { Award, TrendingUp, Target } from "react-feather";
import "./LeaderDashboard.css";
import useLeaderDashboard from "./UseLeaderDashboard";
import Feedback from "../../Components/feedback/Feedback";
import LeaderDashboardTable from "./LeaderDashboardTable/LeaderDashboardTable";
import CircularProgress from "@mui/material/CircularProgress";

const formatNumber = (num) => Number(num || 0).toLocaleString("en-US");

const COLORS = {
  MDRT: "#3B82F6",
  COT: "#F59E0B",
  TOT: "#8B5CF6"
};

const LIGHT_COLORS = {
  MDRT: "rgba(59, 130, 246, 0.1)",
  COT: "rgba(245, 158, 11, 0.1)",
  TOT: "rgba(139, 92, 246, 0.1)"
};

const cardIcons = {
  MDRT: <Award />,
  COT: <Target />,
  TOT: <TrendingUp />
};

const LeaderDashboard = () => {
  const { data, loading, error, feedback } = useLeaderDashboard();

  if (loading) {
    return (
      <div className="loading-overlay">
        <CircularProgress
          size={60}
          thickness={4.5}
          sx={{ color: "#004F9F" }}
        />
      </div>
    );
  }

  const requirements = data?.requirements || {};
  const agentPerformance = data?.agent_performance_ranking || [];

  return (
    <div className="leaderDashboard-container">

      {feedback && (
        <Feedback
          message={feedback.message}
          type={feedback.type}
        />
      )}

      <div className="leaderDashboard-cards">
        {["MDRT", "COT", "TOT"].map((key) => {
          const item = requirements[key.toLowerCase()] || {};

          const qualifiedAgents = item?.qualified_agents ?? 0;
          const requirementAmount = formatNumber(item?.requirement_amount);

          return (
            <div
              key={key}
              className={`leaderDashboard-card leaderDashboard-${key}`}
              style={{ borderLeft: `6px solid ${COLORS[key]}` }}
            >
              <div className="leaderDashboard-cardHeader">
                <h4>{key} Requirement</h4>

                <div
                  className="leaderDashboard-agentsCircle"
                  style={{
                    borderColor: COLORS[key],
                    color: COLORS[key],
                    backgroundColor: LIGHT_COLORS[key]
                  }}
                >
                  <span className="number">{qualifiedAgents}</span>
                  <span className="label">AGENTS</span>
                </div>
              </div>

              <h2>{requirementAmount}</h2>

              <p
                className="qualifiedAgents"
                style={{ color: COLORS[key] }}
              >
                {React.cloneElement(cardIcons[key], { size: 14 })}
                {" "}
                <span className="leaderDashboard-badgeText">
                  Qualified Agents
                </span>
              </p>
            </div>
          );
        })}
      </div>

      <LeaderDashboardTable
        agent_performance_ranking={agentPerformance}
      />

    </div>
  );
};

export default LeaderDashboard;